export interface NativeVideoProps {
  src: string;
  posterSrc?: string;
  loop?: boolean;
  autoPlay?: boolean;
  muted?: boolean;
  controls?: boolean;
}

export const NativeVideo = ({
  src,
  posterSrc,
  loop = false,
  autoPlay = false,
  muted = true,
  controls = false,
}: NativeVideoProps) => {
  return (
    <video
      src={src}
      poster={posterSrc}
      loop={loop}
      autoPlay={autoPlay}
      muted={muted}
      controls={controls}
      playsInline
      className="h-full w-full object-cover"
    />
  );
};
